import { InputAdornment, OutlinedInput } from "@mui/material";
import { Search, X } from "lucide-mui";
import { styledComponent } from "../utils/styled";

// Same look as AllFilesPage's search box — reused across AllFiles/Logbook/
// Submissions page toolbars.
const StyledOutlinedInput = styledComponent(OutlinedInput)(({ isDark }) => ({
  width: "284px",
  paddingRight: "6px",
  color: isDark ? "#D5D9DF" : "#434950",
  background: isDark
    ? "linear-gradient(135deg, rgba(67, 73, 80, 0.8) 0%, rgba(49, 54, 59, 0.8) 50%, rgba(49, 54, 59, 0.8) 100%)"
    : "linear-gradient(135deg, rgba(248, 249, 250, 0.8) 0%, rgba(226, 231, 235, 0.9) 50%, #D3DAE1 100%)",
  height: "32px",
  fontSize: "14px",
  fontFamily: "Inter",
  fontWeight: "500",
  textTransform: "none",
  borderColor: isDark ? "#6A707980" : "#D5D9DF",
  borderRadius: "12px",
  justifyContent: "left",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: isDark ? "#6A707980" : "#D5D9DF",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: isDark ? "#6A707980" : "#D5D9DF",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: isDark ? "#6A707980" : "#D5D9DF",
    borderWidth: "1px",
  },
  "& input": {
    padding: "6px 10px",
  },
  "& input::placeholder": {
    fontStyle: "italic",
    color: isDark ? "#A8AEB6  !important" : "#434950 !important",
    opacity: 1,
    fontWeight: "400",
  },
}));

// Generic page-toolbar search box (AllFiles/Logbook/Submissions). Shows a
// clear (X) icon once there's text, otherwise a search icon — same toggle
// AllFilesPage used — so behavior and look stay identical across pages.
export function ToolbarSearchInput({
  isDark,
  value,
  onSearch,
  onClear,
  ...props
}) {
  const iconSx = {
    height: "16px",
    color: isDark ? "#D5D9DF" : "#434950",
    cursor: "pointer",
  };

  return (
    <StyledOutlinedInput
      isDark={isDark}
      value={value}
      endAdornment={
        <InputAdornment position='end'>
          {value ? (
            <X sx={iconSx} onClick={onClear} />
          ) : (
            <Search sx={iconSx} onClick={onSearch} />
          )}
        </InputAdornment>
      }
      {...props}
    />
  );
}
